// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TweetEmbed from "../src/TweetEmbed.bs.js";

var tweetIds = [
  "1305869118000762882",
  "1354175246312595457",
  "1347527685933850625",
  "1350425575308013568",
  "1354507737368031246",
  "1213121313952423937",
  "1109105694790291456",
  "1339987635398426625",
  "1225090098607349760",
  "1326421057222406145",
  "1085184133364469760",
  "1329723731946692608",
  "1331240527648280578",
  "1192212652111450112",
  "1189575825429061633",
  "1200974492262191110",
  "1283798198323208192",
  "1202510642592264193",
  "1288929821737676801",
  "1351499974870228993",
  "1146330605979930624",
  "1336702417518415874",
  "1203732239160414214",
  "1177202828810620928",
  "1335312236018077703",
  "1244655591882186755"
];

function getRandomTweetId(param) {
  return Belt_Array.shuffle(tweetIds)[0];
}

function Index$App(Props) {
  var match = React.useState(function () {
        return Belt_Array.shuffle(tweetIds)[0];
      });
  var setTweetId = match[1];
  var tweetId = match[0];
  var match$1 = React.useState(function () {
        return "light";
      });
  var setTheme = match$1[1];
  var theme = match$1[0];
  return React.createElement("div", undefined, React.createElement("button", {
                  onClick: (function (param) {
                      return Curry._1(setTweetId, (function (param) {
                                    return Belt_Array.shuffle(tweetIds)[0];
                                  }));
                    })
                }, "Random tweet"), React.createElement("button", {
                  onClick: (function (param) {
                      return Curry._1(setTheme, (function (theme) {
                                    if (theme === "light") {
                                      return "dark";
                                    } else {
                                      return "light";
                                    }
                                  }));
                    })
                }, theme === "light" ? "Switch to dark theme" : "Switch to light theme"), React.createElement("h3", undefined, "Tweet id: ", tweetId), React.createElement(TweetEmbed.make, {
                  id: tweetId,
                  theme: theme,
                  onLoad: (function (element) {
                      if (element.TAG === /* Ok */0) {
                        console.log("Tweet loaded: ", element._0);
                        return ;
                      }
                      console.log("Tweet failed to load");
                      
                    })
                }));
}

var App = {
  tweetIds: tweetIds,
  getRandomTweetId: getRandomTweetId,
  make: Index$App
};

var root = document.querySelector("#app");

if (!(root == null)) {
  ReactDom.render(React.createElement(Index$App, {}), root);
}

export {
  App ,
  
}
/* root Not a pure module */
